import React from 'react';
import { BrowserRouter, Routes, Route } from'react-router-dom';
import Home from './pages/Home';
import PokemonDetail from './pages/PokemonDetail';
import Gmax from './pages/Gmax';
import Mega from './pages/Mega';
import Contact from './pages/Contact';
const App = () => {
  return (
<BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/pokemon/:id" element={<PokemonDetail />} />
      <Route path="/gmax" element={<Gmax />} />
      <Route path="/mega" element={<Mega />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Home />} />
    </Routes>
    </BrowserRouter>);
};

export default App;
